export default __webpack_public_path__ + "static/media/banner8.1ada5550.jpg";